import React from 'react';
import PropTypes from 'prop-types';
import { ApiDateType } from 'types/CommonTypes';
import { formatIsoDate } from 'utils/dateFormatter';
import MeasurementEditContainer from 'Measurement/Edit/MeasurementEditContainer';
import MeasurementFetchByDateConnectorApollo from '@dietlabs/components/src/ApolloConnectors/Measurement/MeasurementByDate/MeasurementFetchByDate/MeasurementFetchByDateConnectorApollo';
import MeasurementSaveByDateConnectorApollo from '@dietlabs/components/src/ApolloConnectors/Measurement/MeasurementByDate/MeasurementSaveByDate/MeasurementSaveByDateConnectorApollo';
import MeasurementDeleteByDateConnectorApollo from '@dietlabs/components/src/ApolloConnectors/Measurement/MeasurementByDate/MeasurementDeleteByDate/MeasurementDeleteByDateConnectorApollo';

const MeasurementEdit = () => (
    <MeasurementFetchByDateConnectorApollo date={formatIsoDate(new Date())}>
        {fetchData => (
            <MeasurementSaveByDateConnectorApollo
                date={formatIsoDate(new Date())}
                {...fetchData}
            >
                {saveData => (
                    <MeasurementDeleteByDateConnectorApollo {...saveData}>
                        {deleteData => (
                            <MeasurementEditContainer
                                {...fetchData}
                                {...saveData}
                                {...deleteData}
                            />
                        )}
                    </MeasurementDeleteByDateConnectorApollo>
                )}
            </MeasurementSaveByDateConnectorApollo>
        )}
    </MeasurementFetchByDateConnectorApollo>
);

MeasurementEdit.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            date: ApiDateType,
        }).isRequired,
    }).isRequired,
};

export default MeasurementEdit;
